import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const addonApi = AiseaApiFactory.get("enterpriseAdminAddon");
import moment from 'moment-timezone';

const ADDON_IDS = {
  PORT_MASTER: "1",
  VESSEL_REPORT: "2",
  SECURE_DATAFLOW: "3",
  REGISTERED_TRAVERSER: "4",
  POLARIS: "5",
  ECO_SHIP: "6",
  CREW_TIER1: "7",
  CREW_TIER2: "8",
  CREW_TIER3: "9",
};


export default {

  async addTier3 ({ dispatch }) {
    const res = await addonApi.add();
    if (!res || !res.status) return false;
    await dispatch("fetchAddon");
    return true;

  },

  async fetchAddon ({ commit }) {

    const res = await addonApi.fetch();
    if (!res || !res.status || !res.data.enterprise_addons) return false;

    const tier3 = res.data.enterprise_addons.find(item => {
      return item.addon.id === ADDON_IDS.CREW_TIER3
    });

    if (tier3) {
      commit("SET_IS_TRIAL", false);
      return;
    }

    const tier2 = res.data.enterprise_addons.find(item => {
      return item.addon.id === ADDON_IDS.CREW_TIER2
    });

    if (tier2) {
      const expiredTier = moment(tier2.created_at).add(2, "month").format("YYYY年MM月DD日");
      commit("SET_EXPIRED_TIER", expiredTier);
      commit("SET_IS_TRIAL", true);
      return;
    }

    const tier1 = res.data.enterprise_addons.find(item => {
      return item.addon.id === ADDON_IDS.CREW_TIER2
    });

    if (tier1) {
      const expiredTier = moment(tier1.created_at).add(2, "month").format("YYYY年MM月DD日");
      commit("SET_EXPIRED_TIER", expiredTier);
      commit("SET_IS_TRIAL", true);
      return;
    }

  },


}